import styled from 'styled-components';
import { Heading } from '@alefeducation/ui-elements-library-core';
import SettingItem from './SettingItem';
import { OrganisationSettingVM } from '../../../apollo/queries/organisations/organisationSetting.queries';

const StyledContainer = styled.div`
  width: 80%;
`;

const StyledItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;

  margin-top: 16px;
  margin-left: 8px;
`;

interface Props {
  headerTitle: string;
  showInput?: boolean;
  settings: OrganisationSettingVM[];
  onUpdate: (setting: OrganisationSettingVM) => void;
}

const SettingsCategory = (props: Props) => {
  const { settings, headerTitle, showInput = false, onUpdate } = props;

  return (
    <StyledContainer data-testid="general-settings-container">
      <Heading variant="heading-small">{headerTitle}</Heading>

      <StyledItemsContainer data-testid="general-settings-item-container">
        {settings.map((setting) => {
          const { settingCode } = setting;
          return (
            <SettingItem
              key={settingCode}
              showInput={showInput}
              setting={setting}
              onChange={onUpdate}
            />
          );
        })}
      </StyledItemsContainer>
    </StyledContainer>
  );
};

export default SettingsCategory;
